<div class="main__head">
  @if (!isServer) {
    @defer (on immediate) {
      <main-slider-banners [banners]="mainState.banners()" />
    } @loading {
      <div class="main__banners-placeholder"></div>
    } @placeholder {
      <div class="main__banners-placeholder"></div>
    }
  } @else {
    <div class="main__banners-placeholder"></div>
  }

  <div
    class="right-banner flex h-full w-[28.5rem] flex-col items-center space-y-[2.4rem] overflow-hidden rounded-[2.5rem] bg-[radial-gradient(116.84%_104.06%_at_54.04%_104.06%,#DCFF3F_0%,#359600_100%)] px-[2.4rem] pt-[3rem] custom-transition-bg before:bg-[radial-gradient(116.84%_104.06%_at_54.04%_104.06%,#E6FF76_0%,#4BB114_100%)] lg:mb-[1rem] lg:min-h-[10.6rem] lg:w-full lg:flex-col lg:items-start lg:justify-between lg:space-y-0 lg:rounded-[1.4rem] lg:p-[1.6rem] lg:pr-[9.5rem]"
  >
    <span
      class="max-w-[23.7rem] text-center text-[2.4rem] font-450 leading-[3.2rem] lg:mb-[0.8rem] lg:max-w-full lg:text-left lg:text-[1.5rem] lg:leading-normal"
    >
      <span i18n="@@main.home.usepromoGetbonus1">Активируй промо и получи</span>&nbsp;<span
        i18n="@@main.home.usepromoGetbonus2"
        class="text-[#FFE2BA]"
        >Бонус</span
      >
    </span>
    <div
      class="z-[3] flex h-[5rem] w-full items-center justify-between space-x-[0.6rem] rounded-[1.2rem] bg-[rgba(16,17,30,0.82)] py-[0.6rem] pl-[1.2rem] pr-[0.6rem] pr-[0.7rem] lg:h-[4.2rem] lg:max-w-[19.4rem]"
    >
      <div class="flex h-full flex-grow items-center justify-start space-x-[0.6rem]">
        <i class="icon_new icon_promo text-[2rem] !text-[#CDDBFF] lg:text-[1.8rem]"></i>
        <input
          class="h-full w-full bg-transparent text-[1.3rem] font-350 leading-[1.6rem] text-white placeholder:text-[1.3rem] placeholder:font-350 placeholder:leading-[1.6rem] placeholder:text-[rgba(233,230,246,0.46)] lg:text-[1.2rem] lg:placeholder:text-[1.2rem]"
          placeholder="Введите код"
          [formControl]="userInputCodeControl"
          (keyup.enter)="usePromocode()"
          type="text"
          i18n-placeholder="@@main.home.entercode.placeholder"
        />
      </div>
      <button
        class="group flex h-[3.6rem] w-[3.6rem] shrink-0 items-center justify-center rounded-[1rem] bg-green-400 !text-green-100 custom-transition-all hover:bg-green-500 hover:!text-green-200 disabled:!bg-green-300 disabled:!opacity-50 lg:h-[3rem] lg:w-[3rem]"
        [disabled]="userInputCodeControl.invalid || userInputCodeControl.value!.trim() === '' || isApplying()"
        [class.is-loading]="isApplying()"
        (click)="usePromocode()"
      >
        <i class="icon_new icon_check text-[2rem] custom-transition-all group-disabled:opacity-70 lg:text-[1.6rem]"></i>
      </button>
    </div>
    <img
      loading="lazy"
      fetchpriority="low"
      class="absolute bottom-0 lg:right-0 lg:h-[12.6rem] lg:w-[12.6rem]"
      src="/assets/images/main/shadow.webp"
    />
  </div>
</div>

<div class="main__live-drop-block">
  <div class="main-block">
    <div class="main__block-title sm:!hidden">
      <i class="icon icon_three-lines"></i>
      <span i18n="@@main.live-drop.title">Live drop</span>
    </div>
    @if (mainState.liveDrops().length > 0) {
      <div class="main__live-drops">
        @for (liveDrop of mainState.liveDrops(); track liveDrop.id) {
          <main-live-drop [liveDrop]="liveDrop" [routerLink]="['/profile', liveDrop.user.id]" />
        }
      </div>
    } @else {
      <div class="main__live-drops">
        @for (item of preloadLiveDrops; track $index) {
          <preload-rect className="main__live-drop preload" />
        }
      </div>
    }
  </div>
</div>

@if (!isLg()) {
  <div class="net flex w-full flex-col space-y-[3.2rem] lg:space-y-[1rem]">
    <div class="flex space-x-[2rem] lg:flex-col lg:space-x-0 lg:space-y-[1rem]">
      <mini-games-banner />
      <div class="flex w-full flex-col space-y-[1.6rem] lg:space-y-[1rem]">
        <bonuses-banner />
        <ng-container [ngTemplateOutlet]="depQuizSupport" />
      </div>
    </div>
    <div class="flex flex-col space-y-[1.5rem] lg:space-y-[1rem]">
      <div class="flex space-x-[3.2rem] lg:flex-col lg:space-x-0 lg:space-y-[1rem]">
        <bonus-wheel-banner />
        <div class="flex flex-col space-y-[2rem] lg:w-full lg:space-y-[0.8rem]">
          <ng-container [ngTemplateOutlet]="vipUpgrade" />
          <raffles-banner />
        </div>
      </div>
    </div>
  </div>
} @else {
  <div class="net flex flex-col space-y-[1rem]">
    <mini-games-banner />
    <raffles-banner />
    <ng-container [ngTemplateOutlet]="depQuizSupport" />
    <bonus-wheel-banner />
    <bonuses-banner />
    <ng-container [ngTemplateOutlet]="vipUpgrade" />
  </div>
}

<ng-template #depQuizSupport>
  <div
    class="grid grid-cols-3 grid-rows-1 gap-[1.6rem] lg:grid-cols-2 lg:grid-rows-[auto_auto] lg:gap-x-[0.8rem] lg:gap-y-[1rem]"
  >
    <deposit-banner class="lg:col-span-2" />
    <quiz-banner />
    <support-banner />
  </div>
</ng-template>

<ng-template #vipUpgrade>
  <div class="flex space-x-[2rem] lg:w-full lg:space-x-[0.8rem]">
    <vip-club-banner />
    <upgrade-banner />
  </div>
</ng-template>
